interface Keys {
  [key: string]: string;
}

export const DEFECATION_ANALYTICS: {
  COUNT_NOTIFICATIONS_JA: Keys;
  COUNT_NOTIFICATIONS_EN: Keys;
  COUNT_FECES_BY_TERM: Keys;
  VOLUME_TYPES_JA: Keys;
  VOLUME_TYPES_EN: Keys;
  HARDNESS_TYPES_JA: Keys;
  HARDNESS_TYPES_EN: Keys;
} = {
  COUNT_NOTIFICATIONS_JA: {
    success: '通知成功：便あり',
    none: '未通知：便あり',
    urine: '誤報通知：尿あり',
    failure: '誤報通知：尿・便なし',
  },
  COUNT_NOTIFICATIONS_EN: {
    success: 'With notification: Defecation',
    none: 'No notification: Defecation',
    urine: 'False notification: Urination',
    failure: 'False notification: No urination/defecation',
  },
  COUNT_FECES_BY_TERM: {
    day1: '7:00-13:00',
    day2: '13:00-19:00',
    night1: '19:00-1:00',
    night2: '1:00-7:00',
  },
  VOLUME_TYPES_JA: {
    large: '多',
    medium: '中',
    small: '少',
    bit: '付着',
    none: '無',
  },
  VOLUME_TYPES_EN: {
    large: 'Large',
    medium: 'Medium',
    small: 'Small',
    bit: 'Solied',
    none: 'None',
  },
  HARDNESS_TYPES_JA: {
    korokoro: 'コロコロ便',
    hard: '硬い便',
    littleHard: 'やや硬い便',
    middle: '普通便',
    soft: 'やや軟らかい便',
    littleSoft: '泥状便',
    water: '水様便',
    disimpaction: '摘便',
  },
  HARDNESS_TYPES_EN: {
    korokoro: 'Round/hard stool',
    hard: 'Hard stool',
    littleHard: 'Slightly hard stool',
    middle: 'Regular stool',
    soft: 'Slightly soft stool',
    littleSoft: 'Muddy stool',
    water: 'Watery stool',
    disimpaction: 'Disimpaction',
  },
} as const;
